import { APIClient } from "./axiosClient"
const api = new APIClient();

const path = '/auth';
const baseURL = (window.location.hostname)?.includes('localhost') || (window.location.hostname)?.includes('dev-') ? 'https://dev-console-api.pressai.kr/api/v1' : 'https://console-api.pressai.kr/api/v1';
const authApi = {
  login(data: any) {
    const url = `${path}/login`
    return api.post(url, data, {
      baseURL: baseURL,
    })
  },
  login2FA(data: any) {
    const url = `${path}/verify-2fa-code`
    return api.put(url, data)
  },
  refresh(data: any) {
    const url = `${path}/refresh`
    return api.post(url, data, {
      baseURL: baseURL,
    })
  },
  logout() {
    const url = `${path}/logout`
    return api.post(url, {})
  },
  permissions(params: any = {}) {
    const url = `/permissions/current`
    return api.get(url, params)
  },
  profile(params: any = {}) {
    const url = `${path}/profile`
    return api.get(url, params, {
      baseURL: baseURL,
    })
  },
  myPermissions(params: any = {}) {
    const url = `/permissions/current`
    return api.get(url, params)
  },
}
export default authApi
